import { PlusIcon } from '@heroicons/react/24/outline'

export const AddNewButton = ({
  onClick,
  children,
  props,
}: {
  onClick: () => void
  children: React.ReactNode
  props?: React.ButtonHTMLAttributes<HTMLButtonElement>
}) => (
  <>
    <button
      type='button'
      className='btn btn-xs btn-primary'
      onClick={onClick}
      {...props}
    >
      <PlusIcon
        width={16}
        height={16}
      />
      {children}
    </button>
  </>
)
